import React from 'react';
import { Rectangle, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

export interface RectangleMarkerProps {
    key: string;
    color: string;
    position: any;
    radius: number;
    fteDVMs: number;
    showTooltip: boolean;
    name: string;
    opacity: number;
    isAnimated: boolean;
    onClick?: (event: any) => void;
}

export const RectangleMarker = (props: RectangleMarkerProps) => {
    const latFactor = 1 / 110540;
    const lngFactor =
        1 / (111320 * Math.cos((props.position[0] * Math.PI) / 180));
    const sizeLat = props.radius * latFactor * 0.8;
    const sizeLng = props.radius * lngFactor * 0.8;

    const rectBounds: [[number, number], [number, number]] = [
        [props.position[0] - sizeLat, props.position[1] - sizeLng],
        [props.position[0] + sizeLat, props.position[1] + sizeLng],
    ];

    const handleClick = (event: any) => {
        if (props.onClick) {
            props.onClick(event);
        }
    };

    return (
        <Rectangle
            pane="markerPane"
            eventHandlers={{
                click: handleClick,
            }}
            key={`${props.key}-${props.opacity}`}
            bounds={rectBounds}
            color="transparent"
            weight={0}
            fillColor={props.color}
            fillOpacity={props.opacity}>
            {!props.isAnimated && props.showTooltip && (
                <Tooltip direction="top">
                    FTE DVMs: {props.fteDVMs} | Type: {props.name}
                </Tooltip>
            )}
        </Rectangle>
    );
};
